// Single source of truth for Quarkle Pro pricing shown to the client.
// NOTE: this is display-only — it does not reflect coupons/promos applied
// server-side at checkout, since the subscription API returns no price field.
// See app/payment-status/page.jsx for the caveat this implies for conversion
// tracking value accuracy.
export const PRO_PLAN_PRICES = {
  pro: 19.99,
  "pro-yearly": 120,
} as const;

export type PlanKey = keyof typeof PRO_PLAN_PRICES;

export function getPlanPrice(plan) {
  return PRO_PLAN_PRICES[plan] ?? PRO_PLAN_PRICES.pro;
}

// First month is discounted at checkout via a Stripe coupon.
export const PRO_FIRST_MONTH_PRICE = 4.99;

// The one list of what Pro actually gates, mirroring app/pro/page.jsx ("the four
// reasons pro exists"). Previously each upsell surface hand-wrote its own and
// they disagreed — the upgrade popup promised "unlimited" when Pro is capped at
// 200x basic, and /pricing said 100x. Ordered most-compelling first so a smaller
// surface can slice() without the copy reading oddly.
export const PRO_BENEFITS = [
  { emp: "200x the daily usage", rest: ", so a long revision session never hits a wall." },
  { emp: "open expression", rest: " for mature themes and violence. no content wall." },
  { emp: "every model, not just auto", rest: " — claude, gpt, grok, kimi. you pick per message." },
  {
    emp: "the deeper editorial reports",
    rest: ": developmental, plus a promise ledger and a scene-by-scene tension map.",
  },
] as const;
